/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_EditInputs */



/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Deck_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_edit = /** @type {((inputs?: Deck_EditInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_EditInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica")
	return /** @type {LocalizedString} */ ("Edit")
});